/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlaceholder = createReactComponent("placeholder", "IconPlaceholder", [
  ["path", { d: "M10 20.415a8 8 0 1 0 3 -15.415h-3", key: "svg-0" }],
  ["path", { d: "M13 8l-3 -3l3 -3", key: "svg-1" }],
  ["path", { d: "M7 17l4 -4l-4 -4l-4 4z", key: "svg-2" }]
]);

export { IconPlaceholder as default };
//# sourceMappingURL=IconPlaceholder.js.map
